export default {
  partial_data_flag: "Some fields contain data",
  all_data_flag: "All required fields contain data",
  crf_available_visit: "CRF available for this visit",
  forms_on_visit: "Number of forms entered on this visit",

  field_monitored: "Field has been monitored",
  partial_monitored_flag: "Some fields have been monitored",
  all_fields_monitored: "All required fields have been monitored",

  re_monitor: "Data has changed since monitoring",

  partial_qa_flag: "Some fields have been QC'd",
  all_qa_flag: "All required fields have been QC'd",
  re_qa: "Data Has Changed Since QC",
  field_qa: "Field has been QC'd",

  field_site_signoff: "Field signed by PI",
  crf_site_signoff: "PI signed",
  re_site_signoff: "Data has changed since PI signed",

  query_resolved: "Query resolved/closed",
  query_responded: "Query responded/answered",
  query_open: "Open query",
  page_query_open: "Query open on page",
  page_query_responded: "Query responded/answered on page",
  page_query_closed: "All queries resolved/closed",
  deviation: "Protocol deviation",
};
